import clsx from "clsx";
import { memo } from "react";
import { Link } from "react-router-dom";
import { CONTACT_DEFAULT_ICONS } from "src/helpers/constants";
import { getFormattedLink } from "src/helpers/utils";
import { EContactType } from "src/pages/Sources/AddContactDetailsModal";
import Icon from "../Icon/Icon";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import { ICON_SIZES } from "src/constants/icons";
import { IButton } from "../Button/Button.types";

interface IContactInfoCard {
  type: EContactType;
  value: string;
  icon: any;
  name: string;
  notes?: string;
  buttons?: IButton[];
}

const ContactInfoCard: React.FC<IContactInfoCard> = ({
  type,
  value,
  name,
  icon,
  notes = "",
  buttons,
}) => {
  return (
    <Link
      className={clsx([
        "flex",
        "flex-row",
        "w-full",
        "bg-gray-50 dark:bg-gray-900/50",
        "p-2 md:p-2",
        "rounded",
        "md:gap-2",
        "gap-2",
        "md:text-sm",
        "text-sm",
      ])}
      to={getFormattedLink({
        type,
        value: value,
      })}
      target={type === EContactType.LINK ? "_blank" : ""}
    >
      <div
        className={clsx([
          "flex",
          "flex-row",
          "gap-1",
          "md:gap-1",
          "flex-grow",
          "flex-shrink",
          "truncate",
          "items-center",
        ])}
      >
        <div>
          <Icon
            name={icon || CONTACT_DEFAULT_ICONS[type as EContactType]}
            size={ICON_SIZES.MD}
            className={clsx(["dark:text-cyan-400", "text-blue-400"])}
          />
        </div>
        <div
          className={clsx([
            "truncate",
            "flex",
            "flex-col",
            "gap-0",
            "justify-center",
          ])}
        >
          <div className={clsx(["text-xs"])}>{name || "Sin nombre"}</div>
          <div className={clsx(["text-xs", "truncate"])}>{value}</div>
          {notes && (
            <div className={clsx(["text-xs", "truncate"])}>{notes}</div>
          )}
        </div>
      </div>
      {buttons?.length ? (
        <div
          onClick={(e) => {
            e.stopPropagation?.();
            e?.preventDefault?.();
          }}
        >
          <ButtonGroup buttons={buttons} />
        </div>
      ) : null}
    </Link>
  );
};

export default memo(ContactInfoCard);
